/** Публичные client sitekey Яндекс SmartCaptcha. Пара к server key — первые 20 символов после ysc1_/ysc2_. */

export const YANDEX_CAPTCHA_CLIENT_STAGING =
    'ysc1_hw7vyQRf7MWUgdFUgNrEhBnyMHfsTWAoil8CQs6pc2328b83'

export const YANDEX_CAPTCHA_CLIENT_PRODUCTION =
    'ysc1_sPLy1XNuJZ5YfNGet5r8rJGcadmUCmpjalPBHyOba1e205b8'

export const yandexCaptchaPairPrefix = (key: string): string =>
    key.slice(5, 25)
